import { absolutePath } from "../../absolutePath";

export const affiliates = {
  update: (id: number) => absolutePath(`admin/paywalls/affiliates/${id}`),
};
